const PAYER_IDS = {
  AETNA: 'Aetna',
  BCBS: 'BCBS',
  CIGNA: 'Cigna',
  HUMANA: 'Humana',
  TRICARE: 'Tricare',
  UHC: 'UHC'
};

export const PAYERS_OPTIONS = [
  {
    id: PAYER_IDS.AETNA,
    label: PAYER_IDS.AETNA
  },
  {
    id: PAYER_IDS.BCBS,
    label: PAYER_IDS.BCBS
  },
  {
    id: PAYER_IDS.CIGNA,
    label: PAYER_IDS.CIGNA
  },
  {
    id: PAYER_IDS.HUMANA,
    label: PAYER_IDS.HUMANA
  },
  {
    id: PAYER_IDS.TRICARE,
    label: PAYER_IDS.TRICARE
  },
  {
    id: PAYER_IDS.UHC,
    label: PAYER_IDS.UHC
  }
];

const PLAN_IDS = {
  AETNA: 'AETNA',
  'Aetna Choice POS II': 'Aetna Choice POS II',
  'AETNA DUAL PPO - SNP': 'AETNA DUAL PPO - SNP',
  'AETNA HMO-SNP': 'AETNA HMO-SNP',
  'AETNA MANAGED CHOICE OPEN ACCESS': 'AETNA MANAGED CHOICE OPEN ACCESS',
  'Aetna Medicare HMO': 'Aetna Medicare HMO',
  'AETNA MEDICARE PPO': 'AETNA MEDICARE PPO',
  'AETNA PPO': 'AETNA PPO',
  'Aetna Select Open Access': 'Aetna Select Open Access',
  'BCBS- FL PPO': 'BCBS- FL PPO',
  'BCBS OF FLORIDA': 'BCBS OF FLORIDA',
  'BCBS-FL HMO': 'BCBS-FL HMO',
  'BCBS-FL PPO': 'BCBS-FL PPO',
  Cigna: 'Cigna',
  'CIGNA CONNECT': 'CIGNA CONNECT',
  'Cigna Global Health': 'Cigna Global Health',
  'CIGNA OAP/PPO': 'CIGNA OAP/PPO',
  'Cigna Open Access Plus': 'Cigna Open Access Plus',
  'Cigna Preferred MCR HMO': 'Cigna Preferred MCR HMO',
  'Cigna True Choice Medicare PPO': 'Cigna True Choice Medicare PPO',
  HUMANA: 'HUMANA',
  'HUMANA  GOLD MDCR REPLACEMENT': 'HUMANA  GOLD MDCR REPLACEMENT',
  'HUMANA DUAL HMO-SNP': 'HUMANA DUAL HMO-SNP',
  'HUMANA DUAL PPO-SNP': 'HUMANA DUAL PPO-SNP',
  'HUMANA GOLD PLUS HMO WELLMED': 'HUMANA GOLD PLUS HMO WELLMED',
  'HUMANA HMO': 'HUMANA HMO',
  'HUMANA MCR ADV HMO': 'HUMANA MCR ADV HMO',
  'HUMANA MCR ADV PPO': 'HUMANA MCR ADV PPO',
  'HUMANA PPO': 'HUMANA PPO',
  'Tricare East': 'Tricare East',
  'Tricare East - EC': 'Tricare East - EC',
  'Tricare for Life': 'Tricare for Life',
  'UHC - GROUP ADV. PPO': 'UHC - GROUP ADV. PPO',
  'UHC - OXFORD PPO': 'UHC - OXFORD PPO',
  'UHC - SUREST': 'UHC - SUREST',
  'UHC - WELLMED': 'UHC - WELLMED',
  'UHC AARP MCR ADV PPO': 'UHC AARP MCR ADV PPO',
  'UHC AARP Medicare Advantage HMO-POS': 'UHC AARP Medicare Advantage HMO-POS',
  'UHC CHOICE PPO': 'UHC CHOICE PPO',
  'UHC DUAL COMPLETE HMO': 'UHC DUAL COMPLETE HMO',
  'UHC DUAL COMPLETE HMO D-SNP Wellmed': 'UHC DUAL COMPLETE HMO D-SNP Wellmed',
  'UHC DUAL HMO/POS-SNP': 'UHC DUAL HMO/POS-SNP',
  'UHC DUAL HMO-SNP': 'UHC DUAL HMO-SNP',
  'UHC DUAL PPO - SNP': 'UHC DUAL PPO - SNP',
  'UHC DUAL PPO SNP': 'UHC DUAL PPO SNP',
  'UHC MCR ADV': 'UHC MCR ADV',
  'UHC MCR ADV CHOICE PPO': 'UHC MCR ADV CHOICE PPO',
  'UHC MCR ADV PPO': 'UHC MCR ADV PPO',
  'UHC MCR ADV. HMO': 'UHC MCR ADV. HMO',
  'UHC PARTIAL DUAL PPO': 'UHC PARTIAL DUAL PPO',
  'United Health Care': 'United Health Care',
  'UNITED HEALTHCARE': 'UNITED HEALTHCARE',
  'UNITED HEALTHCARE CHOICE PLUS': 'UNITED HEALTHCARE CHOICE PLUS',
  'United Healthcare Medicare Advantage':
    'United Healthcare Medicare Advantage',
  'United Healthcare Shared services': 'United Healthcare Shared services'
};

export const PLANS_OPTIONS = [
  {
    id: PLAN_IDS.AETNA,
    label: PLAN_IDS.AETNA,
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['Aetna Choice POS II'],
    label: PLAN_IDS['Aetna Choice POS II'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['AETNA DUAL PPO - SNP'],
    label: PLAN_IDS['AETNA DUAL PPO - SNP'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['AETNA HMO-SNP'],
    label: PLAN_IDS['AETNA HMO-SNP'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['AETNA MANAGED CHOICE OPEN ACCESS'],
    label: PLAN_IDS['AETNA MANAGED CHOICE OPEN ACCESS'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['Aetna Medicare HMO'],
    label: PLAN_IDS['Aetna Medicare HMO'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['AETNA MEDICARE PPO'],
    label: PLAN_IDS['AETNA MEDICARE PPO'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['AETNA PPO'],
    label: PLAN_IDS['AETNA PPO'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['Aetna Select Open Access'],
    label: PLAN_IDS['Aetna Select Open Access'],
    payerId: PAYER_IDS.AETNA
  },
  {
    id: PLAN_IDS['BCBS- FL PPO'],
    label: PLAN_IDS['BCBS- FL PPO'],
    payerId: PAYER_IDS.BCBS
  },
  {
    id: PLAN_IDS['BCBS OF FLORIDA'],
    label: PLAN_IDS['BCBS OF FLORIDA'],
    payerId: PAYER_IDS.BCBS
  },
  {
    id: PLAN_IDS['BCBS-FL HMO'],
    label: PLAN_IDS['BCBS-FL HMO'],
    payerId: PAYER_IDS.BCBS
  },
  {
    id: PLAN_IDS['BCBS-FL PPO'],
    label: PLAN_IDS['BCBS-FL PPO'],
    payerId: PAYER_IDS.BCBS
  },
  {
    id: PLAN_IDS.Cigna,
    label: PLAN_IDS.Cigna,
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['CIGNA CONNECT'],
    label: PLAN_IDS['CIGNA CONNECT'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['Cigna Global Health'],
    label: PLAN_IDS['Cigna Global Health'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['CIGNA OAP/PPO'],
    label: PLAN_IDS['CIGNA OAP/PPO'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['Cigna Open Access Plus'],
    label: PLAN_IDS['Cigna Open Access Plus'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['Cigna Preferred MCR HMO'],
    label: PLAN_IDS['Cigna Preferred MCR HMO'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS['Cigna True Choice Medicare PPO'],
    label: PLAN_IDS['Cigna True Choice Medicare PPO'],
    payerId: PAYER_IDS.CIGNA
  },
  {
    id: PLAN_IDS.HUMANA,
    label: PLAN_IDS.HUMANA,
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA  GOLD MDCR REPLACEMENT'],
    label: PLAN_IDS['HUMANA  GOLD MDCR REPLACEMENT'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA DUAL HMO-SNP'],
    label: PLAN_IDS['HUMANA DUAL HMO-SNP'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA DUAL PPO-SNP'],
    label: PLAN_IDS['HUMANA DUAL PPO-SNP'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA GOLD PLUS HMO WELLMED'],
    label: PLAN_IDS['HUMANA GOLD PLUS HMO WELLMED'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA HMO'],
    label: PLAN_IDS['HUMANA HMO'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA MCR ADV HMO'],
    label: PLAN_IDS['HUMANA MCR ADV HMO'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA MCR ADV PPO'],
    label: PLAN_IDS['HUMANA MCR ADV PPO'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['HUMANA PPO'],
    label: PLAN_IDS['HUMANA PPO'],
    payerId: PAYER_IDS.HUMANA
  },
  {
    id: PLAN_IDS['Tricare East'],
    label: PLAN_IDS['Tricare East'],
    payerId: PAYER_IDS.TRICARE
  },
  {
    id: PLAN_IDS['Tricare East - EC'],
    label: PLAN_IDS['Tricare East - EC'],
    payerId: PAYER_IDS.TRICARE
  },
  {
    id: PLAN_IDS['Tricare for Life'],
    label: PLAN_IDS['Tricare for Life'],
    payerId: PAYER_IDS.TRICARE
  },
  {
    id: PLAN_IDS['UHC - GROUP ADV. PPO'],
    label: PLAN_IDS['UHC - GROUP ADV. PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC - OXFORD PPO'],
    label: PLAN_IDS['UHC - OXFORD PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC - SUREST'],
    label: PLAN_IDS['UHC - SUREST'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC - WELLMED'],
    label: PLAN_IDS['UHC - WELLMED'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC AARP MCR ADV PPO'],
    label: PLAN_IDS['UHC AARP MCR ADV PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC AARP Medicare Advantage HMO-POS'],
    label: PLAN_IDS['UHC AARP Medicare Advantage HMO-POS'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC CHOICE PPO'],
    label: PLAN_IDS['UHC CHOICE PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL COMPLETE HMO'],
    label: PLAN_IDS['UHC DUAL COMPLETE HMO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL COMPLETE HMO D-SNP Wellmed'],
    label: PLAN_IDS['UHC DUAL COMPLETE HMO D-SNP Wellmed'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL HMO/POS-SNP'],
    label: PLAN_IDS['UHC DUAL HMO/POS-SNP'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL HMO-SNP'],
    label: PLAN_IDS['UHC DUAL HMO-SNP'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL PPO - SNP'],
    label: PLAN_IDS['UHC DUAL PPO - SNP'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC DUAL PPO SNP'],
    label: PLAN_IDS['UHC DUAL PPO SNP'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC MCR ADV'],
    label: PLAN_IDS['UHC MCR ADV'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC MCR ADV CHOICE PPO'],
    label: PLAN_IDS['UHC MCR ADV CHOICE PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC MCR ADV PPO'],
    label: PLAN_IDS['UHC MCR ADV PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC MCR ADV. HMO'],
    label: PLAN_IDS['UHC MCR ADV. HMO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UHC PARTIAL DUAL PPO'],
    label: PLAN_IDS['UHC PARTIAL DUAL PPO'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['United Health Care'],
    label: PLAN_IDS['United Health Care'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UNITED HEALTHCARE'],
    label: PLAN_IDS['UNITED HEALTHCARE'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['UNITED HEALTHCARE CHOICE PLUS'],
    label: PLAN_IDS['UNITED HEALTHCARE CHOICE PLUS'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['United Healthcare Medicare Advantage'],
    label: PLAN_IDS['United Healthcare Medicare Advantage'],
    payerId: PAYER_IDS.UHC
  },
  {
    id: PLAN_IDS['United Healthcare Shared services'],
    label: PLAN_IDS['United Healthcare Shared services'],
    payerId: PAYER_IDS.UHC
  }
];

export const PROCESSING_TIMES = {
  'Transforaminal Epidural': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  Arthrocentesis: {
    Aetna: {
      AETNA: 'NAR / Same Day',
      'Aetna Choice POS II': 'NAR / Same Day',
      'AETNA DUAL PPO - SNP': 'NAR / Same Day',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': 'NAR / Same Day',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': 'NAR / Same Day',
      'AETNA PPO': 'NAR / Same Day',
      'Aetna Select Open Access': 'NAR / Same Day'
    },
    BCBS: {
      'BCBS- FL PPO': 'NAR / Same Day',
      'BCBS OF FLORIDA': 'NAR / Same Day',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': 'NAR / Same Day'
    },
    Cigna: {
      Cigna: 'NAR / Same Day',
      'CIGNA CONNECT': 'NAR / Same Day',
      'Cigna Global Health': 'NAR / Same Day',
      'CIGNA OAP/PPO': 'NAR / Same Day',
      'Cigna Open Access Plus': 'NAR / Same Day',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': 'NAR / Same Day'
    },
    Humana: {
      HUMANA: 'NAR / Same Day',
      'HUMANA  GOLD MDCR REPLACEMENT': 'NAR / Same Day',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': 'NAR / Same Day',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': 'NAR / Same Day',
      'HUMANA PPO': 'NAR / Same Day'
    },
    Tricare: {
      'Tricare East': 'NAR / Same Day',
      'Tricare East - EC': 'NAR / Same Day',
      'Tricare for Life': 'NAR / Same Day'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': 'NAR / Same Day',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Facet Joint Injection/MBB': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Sacroiliac Joint Injection': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Intrathecal Pump': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Trigger Point Injection': {
    Aetna: {
      AETNA: 'NAR / Same Day',
      'Aetna Choice POS II': 'NAR / Same Day',
      'AETNA DUAL PPO - SNP': 'NAR / Same Day',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': 'NAR / Same Day',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': 'NAR / Same Day',
      'AETNA PPO': 'NAR / Same Day',
      'Aetna Select Open Access': 'NAR / Same Day'
    },
    BCBS: {
      'BCBS- FL PPO': 'NAR / Same Day',
      'BCBS OF FLORIDA': 'NAR / Same Day',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': 'NAR / Same Day'
    },
    Cigna: {
      Cigna: 'NAR / Same Day',
      'CIGNA CONNECT': 'NAR / Same Day',
      'Cigna Global Health': 'NAR / Same Day',
      'CIGNA OAP/PPO': 'NAR / Same Day',
      'Cigna Open Access Plus': 'NAR / Same Day',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': 'NAR / Same Day'
    },
    Humana: {
      HUMANA: 'NAR / Same Day',
      'HUMANA  GOLD MDCR REPLACEMENT': 'NAR / Same Day',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': 'NAR / Same Day',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': 'NAR / Same Day',
      'HUMANA PPO': 'NAR / Same Day'
    },
    Tricare: {
      'Tricare East': 'NAR / Same Day',
      'Tricare East - EC': 'NAR / Same Day',
      'Tricare for Life': 'NAR / Same Day'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': 'NAR / Same Day',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Radiofrequency Ablation': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  'Interlaminar Epidural': {
    Aetna: {
      AETNA: '3-5 Business Days',
      'Aetna Choice POS II': '3-5 Business Days',
      'AETNA DUAL PPO - SNP': '3-5 Business Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '3-5 Business Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '3-5 Business Days',
      'AETNA PPO': '3-5 Business Days',
      'Aetna Select Open Access': '3-5 Business Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Business Days',
      'BCBS OF FLORIDA': '7-14 Business Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Business Days'
    },
    Cigna: {
      Cigna: '3-5 Business Days',
      'CIGNA CONNECT': '3-5 Business Days',
      'Cigna Global Health': '3-5 Business Days',
      'CIGNA OAP/PPO': '3-5 Business Days',
      'Cigna Open Access Plus': '3-5 Business Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '3-5 Business Days'
    },
    Humana: {
      HUMANA: '3-5 Business Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '3-5 Business Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '3-5 Business Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '3-5 Business Days',
      'HUMANA PPO': '3-5 Business Days'
    },
    Tricare: {
      'Tricare East': '3-5 Business Days',
      'Tricare East - EC': '3-5 Business Days',
      'Tricare for Life': '3-5 Business Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '3-5 Business Days',
      'UHC - OXFORD PPO': 'NAR / Same Day',
      'UHC - SUREST': 'NAR / Same Day',
      'UHC - WELLMED': 'NAR / Same Day',
      'UHC AARP MCR ADV PPO': 'NAR / Same Day',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': 'NAR / Same Day',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': 'NAR / Same Day',
      'UHC DUAL PPO SNP': 'NAR / Same Day',
      'UHC MCR ADV': 'NAR / Same Day',
      'UHC MCR ADV CHOICE PPO': 'NAR / Same Day',
      'UHC MCR ADV PPO': 'NAR / Same Day',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': 'NAR / Same Day',
      'United Health Care': 'NAR / Same Day',
      'UNITED HEALTHCARE': 'NAR / Same Day',
      'UNITED HEALTHCARE CHOICE PLUS': 'NAR / Same Day',
      'United Healthcare Medicare Advantage': 'NAR / Same Day',
      'United Healthcare Shared services': 'NAR / Same Day'
    }
  },
  Kyphoplasty: {
    Aetna: {
      AETNA: '7-14 Days',
      'Aetna Choice POS II': '7-14 Days',
      'AETNA DUAL PPO - SNP': '7-14 Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '7-14 Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '7-14 Days',
      'AETNA PPO': '7-14 Days',
      'Aetna Select Open Access': '7-14 Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Days',
      'BCBS OF FLORIDA': '7-14 Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Days'
    },
    Cigna: {
      Cigna: '7-14 Days',
      'CIGNA CONNECT': '7-14 Days',
      'Cigna Global Health': '7-14 Days',
      'CIGNA OAP/PPO': '7-14 Days',
      'Cigna Open Access Plus': '7-14 Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '7-14 Days'
    },
    Humana: {
      HUMANA: '7-14 Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '7-14 Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '7-14 Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '7-14 Days',
      'HUMANA PPO': '7-14 Days'
    },
    Tricare: {
      'Tricare East': '7-14 Days',
      'Tricare East - EC': '7-14 Days',
      'Tricare for Life': '7-14 Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '7-14 Days',
      'UHC - OXFORD PPO': '7-14 Days',
      'UHC - SUREST': '7-14 Days',
      'UHC - WELLMED': '7-14 Days',
      'UHC AARP MCR ADV PPO': '7-14 Days',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': '7-14 Days',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': '7-14 Days',
      'UHC DUAL PPO SNP': '7-14 Days',
      'UHC MCR ADV': '7-14 Days',
      'UHC MCR ADV CHOICE PPO': '7-14 Days',
      'UHC MCR ADV PPO': '7-14 Days',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': '7-14 Days',
      'United Health Care': '7-14 Days',
      'UNITED HEALTHCARE': '7-14 Days',
      'UNITED HEALTHCARE CHOICE PLUS': '7-14 Days',
      'United Healthcare Medicare Advantage': '7-14 Days',
      'United Healthcare Shared services': '7-14 Days'
    }
  },
  Neurostimulator: {
    Aetna: {
      AETNA: '7-14 Days',
      'Aetna Choice POS II': '7-14 Days',
      'AETNA DUAL PPO - SNP': '7-14 Days',
      'AETNA HMO-SNP': '7-14 Business Days',
      'AETNA MANAGED CHOICE OPEN ACCESS': '7-14 Days',
      'Aetna Medicare HMO': '7-14 Business Days',
      'AETNA MEDICARE PPO': '7-14 Days',
      'AETNA PPO': '7-14 Days',
      'Aetna Select Open Access': '7-14 Days'
    },
    BCBS: {
      'BCBS- FL PPO': '7-14 Days',
      'BCBS OF FLORIDA': '7-14 Days',
      'BCBS-FL HMO': '7-14 Business Days',
      'BCBS-FL PPO': '7-14 Days'
    },
    Cigna: {
      Cigna: '7-14 Days',
      'CIGNA CONNECT': '7-14 Days',
      'Cigna Global Health': '7-14 Days',
      'CIGNA OAP/PPO': '7-14 Days',
      'Cigna Open Access Plus': '7-14 Days',
      'Cigna Preferred MCR HMO': '7-14 Business Days',
      'Cigna True Choice Medicare PPO': '7-14 Days'
    },
    Humana: {
      HUMANA: '7-14 Days',
      'HUMANA  GOLD MDCR REPLACEMENT': '7-14 Days',
      'HUMANA DUAL HMO-SNP': '7-14 Business Days',
      'HUMANA DUAL PPO-SNP': '7-14 Days',
      'HUMANA GOLD PLUS HMO WELLMED': '7-14 Business Days',
      'HUMANA HMO': '7-14 Business Days',
      'HUMANA MCR ADV HMO': '7-14 Business Days',
      'HUMANA MCR ADV PPO': '7-14 Days',
      'HUMANA PPO': '7-14 Days'
    },
    Tricare: {
      'Tricare East': '7-14 Days',
      'Tricare East - EC': '7-14 Days',
      'Tricare for Life': '7-14 Days'
    },
    UHC: {
      'UHC - GROUP ADV. PPO': '7-14 Days',
      'UHC - OXFORD PPO': '7-14 Days',
      'UHC - SUREST': '7-14 Days',
      'UHC - WELLMED': '7-14 Days',
      'UHC AARP MCR ADV PPO': '7-14 Days',
      'UHC AARP Medicare Advantage HMO-POS': '7-14 Business Days',
      'UHC CHOICE PPO': '7-14 Days',
      'UHC DUAL COMPLETE HMO': '7-14 Business Days',
      'UHC DUAL COMPLETE HMO D-SNP Wellmed': '7-14 Business Days',
      'UHC DUAL HMO/POS-SNP': '7-14 Business Days',
      'UHC DUAL HMO-SNP': '7-14 Business Days',
      'UHC DUAL PPO - SNP': '7-14 Days',
      'UHC DUAL PPO SNP': '7-14 Days',
      'UHC MCR ADV': '7-14 Days',
      'UHC MCR ADV CHOICE PPO': '7-14 Days',
      'UHC MCR ADV PPO': '7-14 Days',
      'UHC MCR ADV. HMO': '7-14 Business Days',
      'UHC PARTIAL DUAL PPO': '7-14 Days',
      'United Health Care': '7-14 Days',
      'UNITED HEALTHCARE': '7-14 Days',
      'UNITED HEALTHCARE CHOICE PLUS': '7-14 Days',
      'United Healthcare Medicare Advantage': '7-14 Days',
      'United Healthcare Shared services': '7-14 Days'
    }
  }
};

export const GUIDELINES = [
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Medicare',
    initial: [
      'Diagnosis of Radicular Pain,  Radiculopathy or Neurogenic Claudication',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL imporvement',
      '(Can be repeated after 14 days of non relief to try a differen level or approach)'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Aetna',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging done within last 24 months',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 3 sessions per region per 6 Months',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'UHC',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Florida Blue',
    initial: [
      'Diagnosis of  Radiculopathy',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 6 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Anthem ',
    initial: [
      'Diagnosis of Radicular Pain,  Radiculopathy or Neurogenic Claudication',
      'Supported by Imaging done within last 18 months confirming either of the following',
      'Nerve Root Compression',
      'Spinal Stenosis',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 1 vertebral level Bilaterally or 2 vertebral levels unilaterally',
      'Max 4 sessions per 12 months per region',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Humana',
    initial: ['Diagnosis of Radicular Pain', '4 Weeks of Conservative Care'],
    repeat: [
      '>50% Pain Relief for atleast 2 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 1 vertebral level Bilaterally or 2 vertebral levels unilaterally',
      'Max 4 sessions per 12 months per region',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Transforaminal Epidural',
    payerId: 'Cigna',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging done within last 24 months',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 3 sessions per region per 6 months',
      'Max 4 sessions per region per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Medicare',
    initial: [
      'Diagnosis of Radicular Pain,  Radiculopathy or Neurogenic Claudication',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL imporvement',
      '(Can be repeated after 14 days of non relief to try a differen level or approach)'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Aetna',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging done within last 24 months',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 3 sessions per region per 6 Months',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'UHC',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 4 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Florida Blue',
    initial: [
      'Diagnosis of  Radiculopathy',
      'Supported by Imaging',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 6 sessions per region  per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Anthem ',
    initial: [
      'Diagnosis of Radicular Pain,  Radiculopathy or Neurogenic Claudication',
      'Supported by Imaging done within last 18 months confirming either of the following',
      'Nerve Root Compression',
      'Spinal Stenosis',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 3 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 1 vertebral level Bilaterally or 2 vertebral levels unilaterally',
      'Max 4 sessions per 12 months per region',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Humana',
    initial: ['Diagnosis of Radicular Pain', '4 Weeks of Conservative Care'],
    repeat: [
      '>50% Pain Relief for atleast 2 months and functional / ADL improvement and return of pain'
    ],
    limitations: [
      'Max 1 vertebral level Bilaterally or 2 vertebral levels unilaterally',
      'Max 4 sessions per 12 months per region',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Interlaminar Epidural',
    payerId: 'Cigna',
    initial: [
      'Diagnosis of Radicular Pain',
      'Supported by Imaging done within last 24 months',
      '4 Weeks of Conservative Care'
    ],
    repeat: [
      '>50% Pain Relief for atleast 2 weeks and functional / ADL improvement'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 3 sessions per region per 6 months',
      'Max 4 sessions per region per 12 months',
      '(3 Regions Cervical, Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Medicare',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '4 weeks of conservative Care'
    ],
    repeat: [
      '80% or more relief from the first block performed after a minimum of 2 weeks'
    ],
    limitations: [
      'Max 2 vertebral levels',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Aetna',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '6 weeks of conservative Care'
    ],
    repeat: ['80% or more relief from the first block'],
    limitations: [
      'Max 3 vertebral levels',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'UHC',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '4 weeks of conservative Care'
    ],
    repeat: ['80% or more relief from the first block'],
    limitations: [
      'Follow Medicare Guidelines',
      'Max 2 vertebral levels',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Florida Blue',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '4 weeks of conservative Care'
    ],
    repeat: [
      '80% or more relief from the first block performed after a minimum of 2 weeks'
    ],
    limitations: [
      'Max 2 sessions per region per 12 months',
      '(4 regions Cervical, Thoracic, Lumbar, and Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Anthem',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '6 weeks of conservative Care'
    ],
    repeat: [
      '80% or more relief from the first block performed after a minimum of 2 weeks'
    ],
    limitations: [
      'Max 2 vertebral levels',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Humana',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '6 weeks of conservative Care within the last 12 months'
    ],
    repeat: [
      '80% or more relief from the first block performed after a minimum of 3 weeks'
    ],
    limitations: [
      'Max 3 vertebral levels',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Facet Joint Injection/MBB',
    payerId: 'Cigna',
    initial: [
      'Pain lasting more than 3 months not associated with radiculopathy',
      '4 weeks of conservative Care'
    ],
    repeat: ['80% or more relief from the first block performed'],
    limitations: [
      'Max 3 Vertebral Levels',
      'Follow Medicare Guidelines for the rest',
      '4 sessions per region per 12 months',
      '(2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Medicare',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: ['50% or more pain relief for atleast 6 months'],
    limitations: [
      'Max 2 vertebral levels',
      'Max 2 RFA sessions per rolling 12 months per region'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Aetna',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: [
      '50% or more pain relief for atleast 12 weeks at an interval of 6 months per level per side'
    ],
    limitations: [
      'Max 3 vertebral levels',
      'One session per 6 months per level per side',
      'Max 2 RFA sessions per rolling 12 months'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'UHC',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 50% or more relief'
    ],
    repeat: [
      '50% or more pain relief for atleast 10 weeks at an interval of 6 months per level per side'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 2 RFA sessions per rolling 12 months per region'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Florida Blue',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: ['  50% or more pain relief for atleast 6 months'],
    limitations: [
      'Max 2 vertebral levels',
      'Max 2 RFA sessions per rolling 12 months per region(3 regions Cervical,Thoracic, Lumbar)'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Anthem ',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: ['  50% or more pain relief for atleast 6 months'],
    limitations: [
      'Max 2 vertebral levels',
      'Max 2 RFA sessions per rolling 12 months per region (2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Humana',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: [
      '50% or more pain relief for atleast 12 weeks at an interval of 6 months per level per side'
    ],
    limitations: [
      'Max 2 vertebral levels',
      'Max 2 RFA sessions per rolling 12 months per region (3 regions Cervical/ Thoracic, or Lumbar or Sacral)'
    ]
  },
  {
    procedureName: 'Radiofrequency Ablation',
    payerId: 'Cigna',
    initial: [
      'All Requirements of Medial Branch Blocks',
      '2 Positive Diagnostic MBBs with 80% or more relief'
    ],
    repeat: [
      '50% or more pain relief for atleast 12 weeks at an interval of 6 months per level per side'
    ],
    limitations: [
      'Max 3 Vertebral Levels',
      'Max 2 RFA sessions per rolling 12 months per region (2 regions Cervical/ Thoracic, or Lumbar/ Sacral)'
    ]
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Medicare',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 3 positive provocative tests',
      '4 weeks of conservative Care'
    ],
    repeat: ['50% or more pain relief for atleast 3 months'],
    limitations: ['Max 4 injections per 12 months']
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Aetna',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 3 positive provocative tests',
      '6 weeks of conservative Care'
    ],
    repeat: ['70% or more pain relief for atleast 7 days'],
    limitations: ['Max 4 injections per 12 months']
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'UHC',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 3 positive provocative tests',
      '4 weeks of conservative Care'
    ],
    repeat: ['50% or more pain relief for atleast 12 weeks'],
    limitations: ['Max 4 injections per 12 months']
  },

  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Florida Blue',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 3 positive provocative tests',
      ' 6 weeks of conservative Care'
    ],
    repeat: ['50% or more pain relief for atleast 6 weeks'],
    limitations: ['Max 4 injections per 12 months']
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Anthem ',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 1 positive provocative tests',
      '6 weeks of conservative Care'
    ],
    repeat: [
      '50% or more pain relief for atleast 6 weeks at an interval of atleast 3 months between injections'
    ],
    limitations: ['Max 3 injections per 12 months']
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Humana',
    initial: [
      'Low back pain lasting more than 3 months not associated with radiculopathy',
      'Atleast 3 positive provocative tests',
      '4 weeks of conservative Care'
    ],
    repeat: [
      '75% or more pain relief for atleast 2 weeks at an interval of atleast 2 months between injections'
    ],
    limitations: ['Max 4 injections per 12 months']
  },
  {
    procedureName: 'Sacroiliac Joint Injection',
    payerId: 'Cigna',
    initial: [
      'Low back pain  not associated with radiculopathy',
      'Atleast 2 positive provocative tests',
      '12 weeks of conservative Care in the past 12 months'
    ],
    repeat: ['50% or more pain relief for atleast 3 months'],
    limitations: ['Max 4 injections per 12 months']
  }
];
